export default {
    form: {
        date_of_birth: {
            source: 'soporto_external_form',
            soportoFormType: 'date_of_birth',
            includeOptions: {
                issueTypes: ['privacy'],
                issueSubTypes: { privacy: ['date_of_birth'] }
            }
        },

        // California Privacy Rights Act (CPRA)
        cpra: {
            source: 'soporto_external_form',
            soportoFormType: 'cpra',
            includeOptions: {
                issueTypes: ['privacy'],
                issueSubTypes: { privacy: ['personalised_ads_opt_out_do_not_sell_my_data'] }
            },
            predefinedFields: {
                message: 'Player has requested to not sell or share my Information/Personalised Adverts Opt-Out'
            },
            hideFields: ['message'],
            disableFields: ['issueType', 'issueSubType']
        },

        gifting_card: {
            source: 'soporto_external_form',
            soportoFormType: 'gifting_card',
            includeOptions: {
                issueTypes: ['purchase'],
                issueSubTypes: { purchase: ['gifting_card'] }
            }
        },

        rtbf: {
            source: 'soporto_external_form',
            soportoFormType: 'rtbf',
            includeOptions: {
                issueTypes: ['privacy'],
                issueSubTypes: { privacy: ['permanently_delete_my_account'] }
            },
            predefinedFields: {
                message: 'Player has requested to permanently delete its account.',
                platform: '""',
                game: '""'
            },
            hideFields: ['message', 'platform', 'game'],
            disableFields: ['issueType', 'issueSubType']
        },

        community_report_abuse: {
            source: 'soporto_external_form',
            soportoFormType: 'community_report_abuse',
            hideFields: [],
            disableFields: ['issueType'],
            predefinedFields: {
                issueType: 'community_report_abuse',
            }
        },

        community_appeal_moderation: {
            source: 'soporto_external_form',
            soportoFormType: 'community_appeal_moderation',
            disableFields: ['issueType'],
            hideFields: [],
            includeOptions: {
                issueTypes: ['community_report_abuse'],
                issueSubTypes: { community_report_abuse: ['community_appeal_moderation', 'appeal_account_decision'] }
            },
            predefinedFields: {
                issueType: 'community_report_abuse',
                issueSubType: 'community_appeal_moderation',
            }
        },

        //related to all stars report cheaters and appeal decision
        in_game_appeal_account_decision: {
            source: 'soporto_external_form',
            soportoFormType: 'in_game_appeal_account_decision',
            hideFields: [],
            disableFields: ['issueType', 'issueSubType', 'game'],
            includeOptions: {
                games: ['candycrush'],
                issueTypes: ['community_report_abuse'],
                issueSubTypes: { community_report_abuse: ['appeal_account_decision'] }
            },
            predefinedFields: {
                issueType: 'community_report_abuse',
                issueSubType: 'appeal_account_decision',
                games: 'candycrush'
            }
        },

        crusher_club: {
            source: 'soporto_external_form',
            soportoFormType: 'crusher_club',
            hideFields: [],
            disableFields: ['issueType'],
            includeOptions: {
                issueTypes: ['purchase'],
                issueSubTypes: { purchase: ['unsuccessful_purchase', 'accidental_purchase', 'purchase_not_received',
                        'payment_queries', 'overcharged_purchase'] }
            },
            predefinedFields: {
                issueType: 'purchase',
            }
        },

        direct_checkout: {
            source: 'soporto_external_form',
            soportoFormType: 'direct_checkout',
            hideFields: [],
            disableFields: ['issueType'],
            includeOptions: {
                issueTypes: ['purchase'],
                issueSubTypes: { purchase: ['unsuccessful_purchase', 'accidental_purchase', 'purchase_not_received',
                        'payment_queries', 'overcharged_purchase'] }
            },
            predefinedFields: {
                issueType: 'purchase'
            }
        },

        community: {
            source: 'soporto_external_form',
            soportoFormType: 'community',
            excludeOptions: {
                issueSubTypes: ['date_of_birth']
            }
        },

        help_center: {
            source: 'soporto_external_form',
            soportoFormType: 'help_center',
            excludeOptions: {
                issueSubTypes: ['date_of_birth']
            }
        },

        terms_and_conditions: {
            source: 'soporto_external_form',
            soportoFormType: 'terms_and_conditions',
            includeOptions: {
                issueTypes: ['privacy'],
            },
            excludeOptions: {
                issueSubTypes: ['date_of_birth']
            }
        },

        privacy_policy: {
            source: 'soporto_external_form',
            soportoFormType: 'privacy_policy',
            includeOptions: {
                issueTypes: ['privacy'],
            },
            excludeOptions: {
                issueSubTypes: ['date_of_birth']
            }
        },

        lifesavers: {
            source: 'soporto_external_form',
            soportoFormType: 'lifesavers',
            hideFields: ['platform'],
            disableFields: ['issueType', 'issueSubType', 'game', 'platform'],
            includeOptions: {
                games: ['candycrush'],
                issueTypes: ['event_issues'],
                issueSubTypes: { event_issues: ['reward_not_received'] },
                platforms: ['mobile']
            },
            predefinedFields: {
                issueType: 'event_issues',
                issueSubType: 'reward_not_received',
                game: 'candycrush',
                platform: 'mobile'
            }
        },

        mcdonalds: {
            source: 'soporto_external_form',
            soportoFormType: 'mcdonalds',
            hideFields: ['platform'],
            disableFields: ['issueType', 'issueSubType', 'game', 'platform'],
            includeOptions: {
                games: ['candycrush'],
                issueTypes: ['event_issues'],
                issueSubTypes: { event_issues: ['reward_not_received'] },
                platforms: ['mobile']
            },
            predefinedFields: {
                issueType: 'event_issues',
                issueSubType: 'reward_not_received',
                game: 'candycrush',
                platform: 'mobile'
            }
        },

        csol_appreview: {
            source: 'soporto_external_form',
            soportoFormType: 'csol_appreview',
            hideFields: [],
            disableFields: ['game'],
            includeOptions: {
                games: ['candysolitaire']
            },
            predefinedFields: {
                games: 'candysolitaire'
            }
        },

        hc_bugs_and_issues: {
            source: 'soporto_external_form',
            soportoFormType: 'hc_bugs_and_issues',
            hideFields: [],
            disableFields: ['issueType'],
            includeOptions: {
                issueTypes: ['gameplay_progress'],
                issueSubTypes: { gameplay_progress: ['game_crash', 'live_tickets_issue', 'level_bug',
                        'game_freeze', 'connection_issues'] }
            },
            predefinedFields: {
                issueType: 'gameplay_progress'
            }
        },

        instant_games: {
            source: 'soporto_external_form',
            soportoFormType: 'instant_games',
            excludeOptions: {
                issueSubTypes: ['date_of_birth']
            }
        },

        default: {
            source: 'soporto_external_form',
            soportoFormType: 'generic_form',
            excludeOptions: {
                issueSubTypes: ['date_of_birth']
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Form/formsConfiguration.js